module.exports = __webpack_public_path__ + "static/media/15-01.ef1b13dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/videos/15-01.png
// module id = 117
// module chunks = 0